import React, { Component } from "react";
import { Col, Form, Row, Typography } from "antd";
import PropTypes from "prop-types";
import { withApollo } from "react-apollo";
import FromInput from "../../../../../../components/user/from/Input";

class WelfareListStudyPaymentInPersonnelInformation extends Component {
  render() {
    const { rawData } = this.props;

    return (
      <Row gutter={16} type="flex" justify="left" align="top" className="">
        <Col md={24} className="mb-3">
          <Typography.Text className="color-red">
            <span style={{ fontSize: "18px" }}>ข้อมูลบุคลากร</span>
          </Typography.Text>
        </Col>
        <Col md={12} className="mb-2">
          <FromInput
            disabled={true}
            value={rawData?.empName || "-"}
            required={true}
            name={"empName"}
            label="ชื่อ-นามสกุล"
            mode={"text"}
          />
        </Col>
        <Col md={12} className="mb-2">
          <FromInput
            disabled={true}
            value={rawData?.position || "-"}
            required={true}
            name={"position"}
            label="ตำแหน่ง"
            mode={"text"}
          />
        </Col>
        <Col md={12} className="mb-2">
          <FromInput
            disabled={true}
            value={rawData?.empGroup || "-"}
            required={true}
            name={"empGroup"}
            label="ประเภทบุคลากร"
            mode={"text"}
          />
        </Col>
        <Col md={12} className="mb-2">
          <FromInput
            disabled={true}
            value={rawData?.empLevel || "-"}
            required={true}
            name={"empLevel"}
            label="ระดับ"
            mode={"text"}
          />
        </Col>
        <Col md={12} className="mb-2">
          <FromInput
            disabled={true}
            value={rawData?.organizationName || "-"}
            required={true}
            name={"organizationName"}
            label="สำนักงาน"
            mode={"text"}
          />
        </Col>
        <Col md={12} className="mb-2">
          <FromInput
            disabled={true}
            value={rawData?.departmentName || "-"}
            required={true}
            name={"departmentName"}
            label="ฝ่าย"
            mode={"text"}
          />
        </Col>
        <Col md={12} className="mb-2">
          <FromInput
            disabled={true}
            value={rawData?.divisionName || "-"}
            required={true}
            name={"divisionName"}
            label="งาน"
            mode={"text"}
          />
        </Col>
      </Row>
    );
  }
}

WelfareListStudyPaymentInPersonnelInformation.defaultProps = {
  autoFocus: false,
};

WelfareListStudyPaymentInPersonnelInformation.propTypes = {
  afterSubmit: PropTypes.func,
  forgotLink: PropTypes.string,
  autoFocus: PropTypes.bool,
};

const WrappedWelfareListStudyPaymentInPersonnelInformation = Form.create()(
  WelfareListStudyPaymentInPersonnelInformation
);

export default withApollo(WrappedWelfareListStudyPaymentInPersonnelInformation);
